import * as React from "react";
import {Dialog} from "shared/controls/Dialogs/core/Dialog";
import {FontAwesomeIcon} from "shared/core/Controls/FontAwesome/FontAwesomeIcon";
import {faPlus} from "@fortawesome/free-solid-svg-icons/faPlus";
import {faCheck} from "@fortawesome/free-solid-svg-icons/faCheck";
import 'codemirror/addon/display/autorefresh'
import {ToastService} from "shared/core/services/ToastService";
import {DocumentManager} from "PDFImporter/Manager/PDFManager/DocumentManager";
import {FormulaAutocomplete} from "./FormulaAutocomplete";
import {FieldSettingsOptions, Formula} from "PDFImporter/Manager/PDFManager/DocumentManager.Options";

import './CustomCodeMirrorParser';
import 'codemirror/addon/edit/matchbrackets';
import 'codemirror/mode/htmlmixed/htmlmixed';
import 'codemirror/mode/xml/xml';
import 'codemirror/mode/javascript/javascript';
import 'codemirror/mode/css/css';
import 'codemirror/mode/php/php';
import 'codemirror/lib/codemirror.css';
import 'codemirror/addon/display/autorefresh';
import 'codemirror/addon/hint/show-hint.css';
import 'codemirror/addon/hint/show-hint';
import 'codemirror/addon/hint/css-hint';

import 'codemirror/addon/lint/json-lint';
import 'codemirror/addon/lint/lint';
import 'codemirror/addon/lint/lint.css';
import 'codemirror/addon/lint/css-lint';
import {RNTagDialog} from "shared/controls/RNTags/RNTagDialog";
import {RNTagGroupModel} from "shared/controls/RNTags/RNTagGroup.Model";
import {RNTagItemModel} from "shared/controls/RNTags/RNTagItem.Model";
import './FormulaEditor.css';



let nearley =require('nearley');
let grammar =require('../../../FormulaParser/Core/Grammar.js');

let CodeMirror = require("codemirror");

export class FormulaEditor extends React.Component<FormulaEditorProps, FormulaEditorState> {
    static defaultProps: Partial<FormulaEditorProps> = {
    };
    private autoComplete:FormulaAutocomplete;
    public CodeMirrorNode:HTMLTextAreaElement;
    public CodeMirror:any;
    public Data:RNTagGroupModel[];

    constructor(props: FormulaEditorProps) {
        super(props);
        this.state = {};
        this.TextAreaDisplayed=this.TextAreaDisplayed.bind(this);
        this.autoComplete=new FormulaAutocomplete();
        let fields=this.GetFields();

        this.Data=[];

        let fixedGroup=new RNTagGroupModel({Title:'Fixed',IsOpen:null,onClick:null});
        fixedGroup.Children.push(new RNTagItemModel({Label:'Entry Id',Value:'_entryid',Type:'fixed',onClick:null}));
         if(rnImporterVar.base=='rednaopdfimpwpform')
            fixedGroup.Children.push(new RNTagItemModel({Label:'Geolocation',Value:'_geolocation',Type:'fixed',onClick:null}));
        this.Data.push(fixedGroup);

        let fieldGroup=new RNTagGroupModel({Title:'Fields',IsOpen:null,onClick:null});
        this.props.DocumentManager.GetFields().forEach(item=>{
            fieldGroup.Children.push(new RNTagItemModel({Label:item.Label,Type:'field',Value:item.Id,onClick:null}));
        });
        this.Data.push(fieldGroup);

    }

    public render() {
        return (
            <div className={'FormulaBuilder'} key={this.props.FieldSettings.Id}>
                <label style={{fontWeight:'bold'}}>Formula</label>
                <div style={{border:'#dfdfdf solid 1px'}}>
                    <textarea placeholder={'Set the formula you want to use e.g. $field 1$+$field 2$'} onChange={()=>{}} ref={this.TextAreaDisplayed} style={{width:'100%',height:300}} value={this.GetCode()}/>
                    <div style={{backgroundColor:'#f5f5f5'}}>
                        <button onMouseDown={e=>{e.preventDefault();e.stopPropagation();}} onClick={e=>{e.preventDefault();e.stopPropagation(); this.AddField(e)}} className={'rnbtn rnbtn-primary'} style={{padding:'2px 3px',margin:2,display:'inline-flex',alignItems:'center'}}><FontAwesomeIcon icon={faPlus}/> <span style={{marginLeft:5}}>Add tag to formula</span></button>
                        <button onClick={e=>{e.preventDefault();e.stopPropagation(); this.AddFunction(e)}} className={'rnbtn rnbtn-info'} style={{display:"none", padding:'2px 3px',margin:2,alignItems:'center'}}><FontAwesomeIcon icon={faPlus}/> <span style={{marginLeft:5}}>Add function</span></button>
                        <button onClick={e=>this.Validate(e)} className={'rnbtn rnbtn-success'} style={{marginLeft:5,padding:'2px 3px',margin:2,display:'inline-flex',alignItems:'center'}}><FontAwesomeIcon icon={faCheck}/> <span style={{marginLeft:5}}>Validate</span></button>
                    </div>
                </div>
            </div>
        )
    }


    private async AddField(e: React.MouseEvent<HTMLButtonElement>) {
        e.preventDefault();

        let result:any =await Dialog.Show(<RNTagDialog Data={this.Data} />) as any;
        let fields=this.props.DocumentManager.GetFields();


        if(result!=null)
        {

            if(result.Item.Type=='field') {
                let field=fields.find(x=>x.Id==result.Value);
                if(field!=null) {
                    this.CodeMirror.replaceSelection(`$Field ${field.Id}$`);
                    this.CodeMirror.focus();
                }
            }

            if(result.Item.Type=='fixed') {
                this.CodeMirror.replaceSelection(`$Fixed "${JSON.stringify(result.Item).replace(/\"/g,"\\\"")}"$`);
                this.CodeMirror.focus();
            }

        }

    }

    private Validate(e: React.MouseEvent<HTMLButtonElement>) {
        e.preventDefault();
        if(this.GetCode().trim()=='') {
            ToastService.SendWarning('The formula is empty! There is nothing to validate.');
            return;
        }

        let result=null;

        try {
            result=this.ParseFormula();

        }catch(e)
        {
            if(e.token!=null) {
                let token = e.token;
                let tokenDisplay = (token.type ? token.type + " token: " : "") + JSON.stringify(token.value !== undefined ? token.value : token);

                if(tokenDisplay=='$'||tokenDisplay=='"$"')
                    tokenDisplay='Field';

                ToastService.SendErrorMessage('Unexpected ' + tokenDisplay);
                return;
            }
            ToastService.SendErrorMessage(e.toString());
            return;
        }

        let missingField=result.Fields?.find(x=>x.Field==null);
        if(missingField!=null)
        {
            ToastService.SendErrorMessage(`Field with id ${missingField.FieldId} not found`)
            return;
        }

        ToastService.SendSuccess('The formula is valid!')

    }

    public TextAreaDisplayed(node:any){
        this.CodeMirrorNode=node;

        if(this.CodeMirrorNode!=null)
        {
            if((this.CodeMirrorNode as any).CodeMirror==null) {
                this.CodeMirror = CodeMirror.fromTextArea(this.CodeMirrorNode, {
                    extraKeys: {"Ctrl-Space": "autocomplete"},
                    matchBrackets: true,
                    autoRefresh: true,
                    mode: 'CustomCodeMirrorParser',
                    gutters: ["CodeMirror-lint-markers"],
                    lineWrapping: true,
                    hintOptions: {
                        hint: (editor, self) => {
                            let result = this.autoComplete.process(editor, this.props.FieldSettings,this.props.DocumentManager);
                            return result == null ? result : result.data;
                        },
                        completeSingle: false
                    },
                    lint: true
                } as any);


                (this.CodeMirrorNode as any).CodeMirror = this.CodeMirror;

                this.CodeMirror.on("blur",  (cm, event) =>{
                    this.CompileFormula();

                });

                this.CodeMirror.on("keydown", function (cm, event) {

                    if (!cm.state.completionActive && /*Enables keyboard navigation in autocomplete list*/
                        event.keyCode != 13) {        /*Enter - do not open autocomplete list just after item has been selected in it*/
                        if (event.key == '$' || event.key == '.') {

                            CodeMirror.commands.autocomplete(cm, null, {completeSingle: false});
                        }
                    }
                });
                this.CodeMirror.on('changes', (instance, change) => {
                    this.CodeMirrorChange(instance, change);
                    let property = this.props.FormulaName;

                    let formula=this.props.FieldSettings.Formulas.find(x=>x.Name=='value');
                    if(formula==null)
                    {
                        formula=new Formula().Merge({Name:'value',Compiled:null});
                        this.props.FieldSettings.Formulas.push(formula);
                    }
                    formula.Code=instance.doc.getValue();
                    formula.Compiled=instance.doc.getValue()!=formula.Code?'':formula.Compiled;

                });

                this.CodeMirror.getDoc().setValue(this.GetCode());
                (window as any).codemirror = this.CodeMirror;
            }
        }


    }

    private CodeMirrorChange(instance: any, object: any[]) {
        let fields=this.props.DocumentManager.GetFields();

        for(let obj of object)
        {
            let startLine=obj.from.line;
            let endLine=startLine+object[0].text.length;
            for(let i=startLine;i<=endLine;i++)
            {
                let lineText=this.CodeMirror.getLine(i);
                let re=/\$Field ([^\$]+)\$/g;
                let m;
                while(m=re.exec(lineText))
                {

                    let label=m[1];
                    let id=m[1];
                    let selectedField=fields.find(x=>x.Id==id);
                    let element:HTMLSpanElement=document.createElement('span');
                    element.className='formulaField';



                    if(selectedField==null)
                    {
                        element.style.color='red';
                        element.innerText='Field not found!';
                        element.title='The field was probably deleted?';
                    }else
                    {
                        element.innerText=selectedField.Label!=''?selectedField.Label:'Id: '+selectedField.Id;
                    }


                    this.CodeMirror.markText({line: i, ch: re.lastIndex-m[0].length}, {line: i, ch: re.lastIndex},{replacedWith:element});
                    //text=text.replace(,this.CreateFieldTag(label,id));

                }

                lineText=this.CodeMirror.getLine(i);
                re=/\$Fixed ([^\$]+)\$/g;
                while(m=re.exec(lineText))
                {

                    let label=m[1];
                    let id=m[1];

                    let element:HTMLSpanElement=document.createElement('span');
                    element.className='formulaField';
                    element.style.backgroundColor='lightcyan';
                    label=label.replace(/\\(.)/mg, "$1");
                    try{
                        let fixed=JSON.parse(label.replace(/\\(.)/mg, "$1").substr(1,label.length-2));
                        element.innerText=fixed.Label;
                    }catch (e) {
                        element.innerText='Invalid';
                    }





                    this.CodeMirror.markText({line: i, ch: re.lastIndex-m[0].length}, {line: i, ch: re.lastIndex},{replacedWith:element});
                    //text=text.replace(,this.CreateFieldTag(label,id));

                }

                /*re=/(Math)/g;
                while(m=re.exec(lineText))
                {
                    this.codeMirror.markText({line: i, ch: re.lastIndex - 5}, {line: i, ch: re.lastIndex }, {className: 'sfFormulaMethod'});
                }

                re=/(Remote)/g;
                while(m=re.exec(lineText))
                {
                    this.codeMirror.markText({line: i, ch: re.lastIndex - 6}, {line: i, ch: re.lastIndex }, {className: 'sfFormulaMethod'});
                }*/


            }
        }
    }


    public GetCode()
    {
        let formula=this.props.FieldSettings.Formulas.find(x=>x.Name=='value');
        if(formula==null)
            return '';
        return formula.Code??'';
    }




    public ParseFormula()
    {
        let formula=this.props.FieldSettings.Formulas.find(x=>x.Name=='value');


        let parser=new nearley.Parser(nearley.Grammar.fromCompiled(grammar));
        try {
            parser.feed(formula.Code);
        }catch(e)
        {
            ToastService.SendErrorMessage('Formula is not valid ');
        }

        return {
            Compiled:parser.results,

        };
    }

    private GetFields() {
        return this.props.DocumentManager.GetFields();
    }

    private async AddFunction(e: React.MouseEvent<HTMLButtonElement>) {
        /*   e.preventDefault();

           let result=await Dialog.Show(<FunctionPickerDialog/>);

           if(result!=null)
           {

               this.CodeMirror.replaceSelection(result);
           }
   */
    }

    private CompileFormula() {
        let formula=this.props.FieldSettings.Formulas.find(x=>x.Name=='value');
        if(formula==null)
        {
            formula=new Formula().Merge({Name:'value'});
            this.props.FieldSettings.Formulas.push(formula);
        }
        formula.Compiled=null;

        try {
            let compiled=this.ParseFormula();
            if(compiled!=null)
            {
                formula.Compiled=compiled.Compiled;
            }
        }catch (e) {

        }
    }
}


//#region ----------------------------------------------------"State and props"------------------------------------------------------------------------------------
interface FormulaEditorProps {
    DocumentManager:DocumentManager;
    FormulaName:string;
    FieldSettings:FieldSettingsOptions;
}

interface FormulaEditorState {

}

//#endregion "My Region"